import { CONSTELLATION_CENTER, CONSTELLATION_SIZE, FULL_ROTATION_RADIANS } from '../constants';

const INNER_RING_RADIUS = (CONSTELLATION_SIZE * 8) / 48;
export const OUTER_RING_RADIUS: number = (CONSTELLATION_SIZE * 14) / 48;
export const INNER_RING_DOT_COUNT = 6;

const OUTER_RING_DOT_COUNT = 12;
const CENTER_DOT_INDEX = 0;
const TOP_ANGLE_RADIANS = -Math.PI / 2;

type RingCoordinates = Readonly<{
	count: number;
	radius: number;
	ringIndex: number;
}>;

export const getRingCoordinates = (index: number): RingCoordinates => {
	if (index === CENTER_DOT_INDEX) {
		return { count: 1, radius: 0, ringIndex: CENTER_DOT_INDEX };
	}

	if (index <= INNER_RING_DOT_COUNT) {
		return { count: INNER_RING_DOT_COUNT, radius: INNER_RING_RADIUS, ringIndex: index - 1 };
	}

	return {
		count: OUTER_RING_DOT_COUNT,
		radius: OUTER_RING_RADIUS,
		ringIndex: index - INNER_RING_DOT_COUNT - 1,
	};
};

export const getRingPoint = (
	index: number,
	count: number,
	radius: number,
	rotation: number,
): Readonly<{ x: number; y: number }> => {
	const angle = TOP_ANGLE_RADIANS + (index / count) * FULL_ROTATION_RADIANS + rotation;
	return {
		x: CONSTELLATION_CENTER + Math.cos(angle) * radius,
		y: CONSTELLATION_CENTER + Math.sin(angle) * radius,
	};
};
